import { render, staticRenderFns } from "./PaymentTransactionDetailDialog.vue?vue&type=template&id=5081b624"
import script from "./PaymentTransactionDetailDialog.vue?vue&type=script&lang=js"
export * from "./PaymentTransactionDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports